import { API } from '@/shared/api/modules';
import type { GetFacilityLevelsOfCareRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilityLevelsOfCareQueryOptions = (
  params: GetFacilityLevelsOfCareRequestDto
) =>
  queryOptions({
    queryKey: ['facility-levels-of-care', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getFacilityLevelsOfCare(params, {
        signal,
      });

      return response;
    },
    placeholderData: keepPreviousData,
  });
